import GroupMetrics from "../../components/Dashboard/GroupMetrics/GroupMetrics";
import { css } from "styled-components/macro";
import { useSettings } from "contexts/SettingsManager/SettingsManager";
import PnlChartPopup from "components/Dashboard/TrendChart/TrendChartContent/PnlChartPopup/PnlChartPopup";
import { useMediaQuery } from "@mui/material";
import { BREAKPOINT_DESKTOP } from "constants/constants";
import OverallBarstack from "components/Dashboard/OverallBarstack/OverallBarstack";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import TrendChart from "components/Dashboard/TrendChart/TrendChart";
import { DASHBOARD_CARD_PROPS } from "pages/DashboardPages/DashboardPagesContent/dashboardPagesContentUtils";
import {
  useContainerDimensionsObserver,
  usePnlPopupTimeRange,
} from "utils/customHooks/genericHooks";
import TrendChartCardControls from "components/Dashboard/TrendChart/TrendChartCardControls/TrendChartCardControls";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { useIsTrendChartExpandedHubletPage } from "pages/DashboardPages/dashboardPagesUtils";
import { TREND_CHART_CARD_ID_HUBLET } from "pages/DashboardPages/dashboardPagesUtils";

export const TodaysProductionCardHubletPage = () => {
  const { width } = useContainerDimensionsObserver(
    ".datepickerAndCharts-size-observer"
  );
  const { isTrendChartVisibleHubletPage } = useSettings();
  const isDesktopOrLarger = useMediaQuery(
    `(min-width: ${BREAKPOINT_DESKTOP}px)`
  );
  const isPrint = useMediaQuery("print");
  const { translate } = useFlightTranslation();
  const pnlPopupTimeRange = usePnlPopupTimeRange();
  const [, setIsTrendChartExpandedHubletPage] =
    useIsTrendChartExpandedHubletPage();
  return (
    <CardWithControls
      title={translate("Today's_Production")}
      className={"Card_TodaysProduction"}
      id={TREND_CHART_CARD_ID_HUBLET}
      {...DASHBOARD_CARD_PROPS}
      customCss={css`
        .cardContent {
          padding-top: 16px;
        }
      `}
      CardConfigControls={<TrendChartCardControls />}
      onCollapse={nextExpanded => {
        setIsTrendChartExpandedHubletPage(nextExpanded);
      }}
    >
      <div className="spacer" style={{ height: 20 }} />
      <ErrorBoundary small={true} id="DatepickerAndCharts_GroupMetrics">
        <GroupMetrics />
      </ErrorBoundary>
      <div className="overallBarstackWrapper">
        <ErrorBoundary small={true} id="DatepickerAndCharts_OverallBarstack">
          <OverallBarstack />
        </ErrorBoundary>
      </div>
      {isTrendChartVisibleHubletPage && (
        <>
          <div
            className="trendChartWrapperHubletPage "
            style={{
              height: isPrint ? 600 : 500,
              marginTop: 10,
              width: "100%",
            }}
          >
            <ErrorBoundary small={true} id="DatepickerAndCharts_TrendChart">
              <TrendChart />
            </ErrorBoundary>
          </div>
          <ErrorBoundary small={true} id="DatepickerAndCharts_PnlChartPopup">
            <PnlChartPopup
              {...(isDesktopOrLarger &&
              // if popup isn't open, don't change its props (causes a re-render)
              pnlPopupTimeRange
                ? {
                    portalContainerSelector:
                      ".datepickerAndCharts-size-observer",
                    containerWidth: width,
                  }
                : {})}
            />
          </ErrorBoundary>
        </>
      )}
    </CardWithControls>
  );
};
